var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4212 11.3888H11.2546V15.5555C11.2546 16.0138 10.8796 16.3888 10.4212 16.3888C9.96289 16.3888 9.58789 16.0138 9.58789 15.5555V11.3888H5.42122C4.96289 11.3888 4.58789 11.0138 4.58789 10.5555C4.58789 10.0972 4.96289 9.72217 5.42122 9.72217H9.58789V5.5555C9.58789 5.09717 9.96289 4.72217 10.4212 4.72217C10.8796 4.72217 11.2546 5.09717 11.2546 5.5555V9.72217H15.4212C15.8796 9.72217 16.2546 10.0972 16.2546 10.5555C16.2546 11.0138 15.8796 11.3888 15.4212 11.3888Z",
    fill: "#0E88FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plus-blue.ea53651d925c7fcf2c62def1ac9b4179.svg";
export { ForwardRef as ReactComponent };